import { createSelector } from '@reduxjs/toolkit';

import { AnalogModel, CheckResult } from '@paragon/contract-library';
import { getGroupingMapWithMultiKeySelector } from '@paragon/utilities';

import { getAnalogModelForActiveComponentDesign } from './getAnalogModelForActiveComponentDesignSelector';
import { getCheckResultsForActiveAnalysisSet } from './getCheckResultsForActiveAnalysisSetSelector';
import { getCheckResultsForActiveLoadCase } from './getCheckResultsForActiveLoadCaseSelector';

export function getCheckResultsByObjectGuid<T extends CheckResult>(
  checkResults: ReadonlyArray<T>,
  analogModel: AnalogModel,
): ReadonlyMap<string, readonly T[]> {
  return getGroupingMapWithMultiKeySelector(checkResults, (checkResult) =>
    checkResult.objects.map((checkedObject) =>
      checkedObject.type === 'Panel'
        ? // Work around a bug fixed by https://github.com/ParagonTruss/ParagonCore/pull/3480. When all old analysis
          // results have been migrated, this special treatment of panels can be removed.
          analogModel.panels.find((panel) => panel.name === checkedObject.name)!.guid
        : checkedObject.guid,
    ),
  );
}

export const getCheckResultsForActiveAnalysisSetByObjectGuid = createSelector(
  getCheckResultsForActiveAnalysisSet,
  getAnalogModelForActiveComponentDesign,
  (checkResults, analogModel) => checkResults && analogModel && getCheckResultsByObjectGuid(checkResults, analogModel),
);

export const getCheckResultsForActiveLoadCaseByObjectGuid = createSelector(
  getCheckResultsForActiveLoadCase,
  getAnalogModelForActiveComponentDesign,
  (checkResults, analogModel) => checkResults && analogModel && getCheckResultsByObjectGuid(checkResults, analogModel),
);
